var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 7L36 4L33 7L30 4L27 7L24 4L21 7L18 4L15 7L12 4V32H6V38C6 41.32 8.68 44 12 44H36C39.32 44 42 41.32 42 38V4L39 7ZM30 40H12C10.9 40 10 39.1 10 38V36H30V40ZM38 38C38 39.1 37.1 40 36 40C34.9 40 34 39.1 34 38V32H16V10H38V38Z",
    fill: "#0D9963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V18H30V14Z",
    fill: "#0D9963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 14H32V18H36V14Z",
    fill: "#0D9963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20H18V24H30V20Z",
    fill: "#0D9963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 20H32V24H36V20Z",
    fill: "#0D9963"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.d8e22820b81c91dd17ac04a352762c6c.svg";
export { ForwardRef as ReactComponent };